module.exports = __webpack_public_path__ + "static/media/ALEGIONELLA-on.56f7cfb4.svg";